<!--FDC产品-->
<template>
  <div class="home-main af_cloud clearfix">
    <div class="main" v-loading="loading">
      <div class="main_title">
        <span class="title-cn">安捷智用产品</span>
        <span class="title-en">/Agilework Products</span>
        <div class="main-title-right" v-loading="loading">
          <el-button size="medium" class="danger" @click="triallDialogOpen"
            >客户试用</el-button
          >
          <el-button size="medium" class="primary" @click="buyFirstDialogOpen"
            >客户购买</el-button
          >
        </div>
      </div>
      <!--筛选部分start-->
      <div class="product-selector_main">
        <div class="selector-left_main">
          <div class="selector-item">
            <span class="title" style="width: 60px;">授权码</span>
            <el-input
              v-model="searchOption.code"
              size="small"
              clearable
            ></el-input>
          </div>
          <div class="selector-item">
            <span class="title" style="width: 70px;">企业名称</span>
            <el-input
              v-model="searchOption.name"
              size="small"
              clearable
            ></el-input>
          </div>
          <div class="selector-item">
            <span class="title" style="width: 100px;">归属伙伴用户</span>
            <el-input
              v-model="searchOption.username"
              size="small"
              clearable
            ></el-input>
          </div>
        </div>
        <div class="selector-right_main">
          <div class="buttons">
            <el-button size="small" class="warning" @click="search"
              >搜索</el-button
            >
            <el-button size="small" @click="restSearch">重置</el-button>
          </div>
        </div>
      </div>
      <!--筛选部分end-->

      <div class="product-main-line"></div>

      <!--产品列表start-->
      <div class="product-main-list">
        <el-table :data="tableData" height="100%" style="width: 100%" stripe>
          <el-table-column width="20"> </el-table-column>
          <el-table-column label="企业授权码">
            <template slot-scope="scope">
              <span>{{ scope.row.code }}</span>
            </template>
          </el-table-column>
          <el-table-column label="企业名称">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="企业联系人">
            <template slot-scope="scope">
              <span>{{ scope.row.contact_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="联系电话">
            <template slot-scope="scope">
              <span>{{ scope.row.mobile }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope">
              <span>{{ scope.row.create_time }}</span>
            </template>
          </el-table-column>
          <el-table-column label="授权过期时间">
            <template slot-scope="scope">
              <span>{{ checkBuyout(scope.row.expire_time) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span>{{ getAuthStatus(scope.row.status) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="归属伙伴用户名">
            <template slot-scope="scope">
              <span>{{ scope.row ? scope.row.user_loginname : "" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注">
            <template slot-scope="scope">
              <span>{{ scope.row.note }}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="470" class="table-status">
            <template slot-scope="scope">
              <!-- <el-button v-if="scope.row.status == 3 && isExpired(scope.row)" size="mini" type="primary" @click="delayClick(scope.$index, scope.row)">延期</el-button> -->
              <el-button
                size="mini"
                type="primary"
                @click="purchaseView(scope.$index, scope.row)"
                >购买查看</el-button
              >
              <el-button
                size="mini"
                type="primary"
                v-if="scope.row.status === 3 && checkBuyout(scope.row.expire_time) !== '买断'"
                @click="renewOpen(scope.$index, scope.row)"
                >购买</el-button
              >
              <el-button
                size="mini"
                type="primary"
                v-if="scope.row.status !== 3 && checkBuyout(scope.row.expire_time) !== '买断'"
                @click="renewOpen(scope.$index, scope.row)"
                >授权码续费</el-button
              >
              <el-button
                size="mini"
                type="primary"
                v-if="scope.row.status !== 3"
                @click="buyModule(scope.$index, scope.row)"
                >增购模块</el-button
              >
              <el-button
                size="mini"
                type="primary"
                v-if="scope.row.status !== 3"
                @click="buySiteOpen(scope.$index, scope.row)"
                >增购站点</el-button
              >
              <el-button
                size="mini"
                type="primary"
                @click="editPasswordOpen(scope.$index, scope.row)"
                >修改密钥</el-button
              >
              <el-button
                size="mini"
                type="primary"
                @click="editCustomerOpen(scope.$index, scope.row)"
                >编辑信息</el-button
              >

              <el-button
                size="mini"
                v-if="is_superuser"
                type="primary"
                @click="authorizationTransfer(scope.$index, scope.row)"
                >授权转移</el-button
              >
              <el-button v-if="scope.row.status == 3 && is_superuser" size="mini" type="primary" @click="trialExtension(scope.$index, scope.row)">试用延期</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination">
        <el-pagination
          :disabled="!pagination.use"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[20, 30, 50, 100]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
      <!--产品列表end-->
    </div>
    <buyDialog ref="buyDialog"></buyDialog>
    <transferDialog ref="transferDialog"></transferDialog>
    <extensionDialog ref="extensionDialog"></extensionDialog>

    <!-- 购买查看 -->
    <el-drawer title="" :visible.sync="drawer" ref="drawerRef" size="70%" :close-on-click-modal="false">
      <div class="drawer_main1">
        <div class="title_main">
          <div class="title_top">
            <span>{{ currentOrg ? currentOrg.name : "" }}</span>
          </div>
          <div class="title_mid">
            <div class="item">
              <span style="width: 90px;">企业授权码：</span>
              <span>{{ currentOrg ? currentOrg.code : "" }}</span>
            </div>
            <div class="item">
              <span style="width: 90px;">企业联系人：</span>
              <span>{{ currentOrg ? currentOrg.contact_name : "" }}</span>
            </div>
            <div class="item">
              <span style="width: 80px;">联系电话：</span>
              <span>{{ currentOrg ? currentOrg.mobile : "" }}</span>
            </div>
            
          </div>
          <div class="title_mid">
            <div class="item">
              <span style="width: 90px;">授权码状态：</span>
              <span>{{
                currentOrg ? getAuthStatus(currentOrg.status) : ""
              }}</span>
            </div>
            <div class="item">
              <span style="width: 90px;">工作用户数：</span>
              <span>{{ currentOrg ? currentOrg.fdc_bi_users : "" }}</span>
            </div>
            <div class="item">
              <span style="width: 90px;">查看用户数：</span>
              <span>{{ currentOrg ? currentOrg.fdc_std_users : "" }}</span>
            </div>
          </div>
          <div class="title_bottom">
            <span>备注：</span>
            <span>{{ currentOrg ? currentOrg.note : "" }}</span>
          </div>
        </div>
        <div class="table_main">
          <el-tabs v-model="activeName">
            <el-tab-pane label="已购模块" name="first">
              <el-table
                :data="purchasedProjects"
                height="100%"
                style="width: 100%"
                v-loading="ordersModulesLoading"
              >
                <el-table-column
                  prop="module_name"
                  width="300"
                  label="模块名称"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.module_name }}</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column
                  prop="module_code"
                  width="200"
                  label="模块代码"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.module_code }}</span>
                  </template>
                </el-table-column> -->
                <el-table-column label="开通时间">
                  <template slot-scope="scope">
                    <span>{{ scope.row.create_time }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="到期时间">
                  <template slot-scope="scope">
                    <span>{{ checkBuyout(scope.row.expire_time) }}</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button
                      v-if="scope.row.status == 3 && is_superuser"
                      size="mini"
                      type="text"
                      @click="trialModuleExtension(scope.$index, scope.row)"
                      >延期</el-button
                    >
                  </template>
                </el-table-column> -->
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="订单列表" name="second">
              <div style="display: flex;height: 100%;flex-direction: column;">
                <div style="height: calc(100% - 32px);">
                  <el-table
                    :data="orderList"
                    height="100%"
                    style="width: 100%"
                    v-loading="ordersModulesLoading"
                  >
                    <el-table-column label="订单号">
                      <template slot-scope="scope">
                        <span>{{ scope.row.code }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="订单明细" min-width="200">
                      <template slot-scope="scope">
                        <span>{{ formatOrderDetail(scope.row) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column width="120" label="时长">
                      <template slot-scope="scope">
                        <span>{{ formatOrderDuration(scope.row) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column width="100" label="订单金额">
                      <template slot-scope="scope">
                        <span>{{ scope.row.price }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="订单日期">
                      <template slot-scope="scope">
                        <span>{{ scope.row.create_time }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="订单备注">
                      <template slot-scope="scope">
                        <span>{{ scope.row.note }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="pagination">
                  <el-pagination
                    :disabled="!orderPagination.use"
                    @size-change="handleSizeChangeOrder"
                    @current-change="handleCurrentChangeOrder"
                    :current-page="orderPagination.currentPage"
                    :page-sizes="[20, 30, 50, 100]"
                    :page-size="orderPagination.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="orderPagination.total"
                  >
                  </el-pagination>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </el-drawer>

    <!-- 修改备注 -->
    <el-dialog
      :before-close="restEditCustomerForm"
      title="编辑信息"
      :visible.sync="editCustomerDialog"
      width="510px"
      class="editCustomerDialog"
    >
      <el-form :model="editCustomerForm" ref="editCustomerForm" :rules="editCustomerFormRules">
        <el-form-item label="授权码" prop="code" :label-width="'100px'">
          <el-input
            v-model="editCustomerForm.code"
            autocomplete="off"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="授权企业名称" prop="name" :label-width="'100px'">
          <el-input
            v-model="editCustomerForm.name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contact_name" :label-width="'100px'">
          <el-input
            v-model="editCustomerForm.contact_name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="mobile" :label-width="'100px'">
          <el-input
            v-model="editCustomerForm.mobile"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item :label-width="'100px'" label="备注" prop="note">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="editCustomerForm.note"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="cancel('editCustomerForm', (editCustomerDialog = false))"
          >取 消</el-button
        >
        <el-button class="primary" @click="editCustomerSubmit">保 存</el-button>
      </div>
    </el-dialog>

    <!--修改密钥-->
    <el-dialog
      :before-close="restEditPasswordForm"
      title="修改密钥"
      :visible.sync="editPasswordDialog"
      width="510px"
      class="editCustomerDialog"
    >
      <el-form
        :model="editPasswordForm"
        ref="editPasswordForm"
        :rules="editPasswordFormRules"
      >
        <el-form-item label="企业名称" prop="name" :label-width="'100px'">
          <el-input
            v-model="editPasswordForm.name"
            autocomplete="off"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="企业授权码" prop="code" :label-width="'100px'">
          <el-input
            v-model="editPasswordForm.code"
            autocomplete="off"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密钥" prop="pass" :label-width="'100px'">
          <el-input
            show-password
            v-model="editPasswordForm.pass"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密钥" prop="checkPass" :label-width="'100px'">
          <el-input
            show-password
            v-model="editPasswordForm.checkPass"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="cancel('editPasswordForm', (editPasswordDialog = false))"
          >取 消</el-button
        >
        <el-button class="primary" @click="editPasswordSubmit">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 增购站点 -->
    <el-dialog
      :before-close="closeBuySiteDialog"
      title="增购站点"
      :visible.sync="buySiteDialog"
      width="700px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form
        v-if="!buySitePayTableShow"
        :model="buySiteForm"
        ref="buySiteForm"
        label-width="110px"
      >
        <el-form-item label="企业名称" prop="name">
          <el-input v-model="buySiteForm.name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="企业授权码" prop="code">
          <el-input v-model="buySiteForm.code" :disabled="true"></el-input>
        </el-form-item>
        <div class="buy-site-info">
          <span>当前站点数</span>
          <span style="margin-left: 20px;">工作用户数</span>
          <span style="margin-left: 5px; font-weight: bold;">{{
            buySiteForm.current_bi_users
          }}</span>
          <span style="margin-left: 20px;">查看用户数</span>
          <span style="margin-left: 5px; font-weight: bold;">{{
            buySiteForm.current_std_users
          }}</span>
        </div>
        <el-form-item label="增购站点数">
          <div>
            <span style="margin-right: 10px;">工作用户数</span>
            <el-input-number
              size="small"
              v-model="buySiteForm.bi_users"
              :min="0"
              :step="1"
            ></el-input-number>
          </div>
          <div style="margin-top: 15px;">
            <span style="margin-right: 10px;">查看用户数</span>
            <el-input-number
              size="small"
              v-model="buySiteForm.std_users"
              :min="0"
              :step="1"
            ></el-input-number>
          </div>
        </el-form-item>
      </el-form>
      <div v-if="buySitePayTableShow" class="clearfix">
        <el-table :data="buySitePayTableData" border style="width: 100%">
          <el-table-column prop="item" label="项目"></el-table-column>
          <el-table-column prop="count" label="数量"></el-table-column>
          <el-table-column prop="days" label="计费天数">
            <template slot-scope="scope">
              <span>{{ scope.row.days }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="价格"></el-table-column>
        </el-table>
        <el-alert
          class="alert"
          style="margin-top: 10px;"
          title="支付描述"
          :type="buySiteAlertType"
          :closable="false"
          :description="buySitePayDescription"
        ></el-alert>
        <el-button
          v-if="buySitePayBtnShow"
          class="primary"
          style="margin-top: 10px; float: right;"
          @click="buySitePay"
          >确认支付</el-button
        >
      </div>
      <div v-if="!buySitePayTableShow" slot="footer" class="dialog-footer">
        <el-button @click="buySiteDialog = false">取 消</el-button>
        <el-button class="primary" @click="buySiteSubmit">预览价格</el-button>
      </div>
    </el-dialog>

    <!-- 授权码续费/购买 -->
    <el-dialog
      :before-close="closeRenewDialog"
      :title="renewDialogTitle"
      :visible.sync="renewDialog"
      width="700px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form
        v-if="!renewPayTableShow"
        :model="renewForm"
        ref="renewForm"
        label-width="110px"
      >
        <el-form-item label="企业名称" prop="name">
          <el-input v-model="renewForm.name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="企业授权码" prop="code">
          <el-input v-model="renewForm.code" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="购买方式" prop="buy_type">
          <el-radio-group v-model="renewForm.buy_type">
            <el-radio :label="1">买断模式</el-radio>
            <el-radio :label="2">按年订阅</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="renewForm.buy_type == 2" label="购买时长">
          <el-input-number
            style="text-align: center;"
            size="small"
            v-model="renewForm.new_months"
            :min="1"
            :max="100"
            :step="1"
          ></el-input-number>
          <span style="margin-left: 10px;">年</span>
        </el-form-item>
      </el-form>
      <div v-if="renewPayTableShow" class="clearfix">
        <el-table :data="renewPayTableData" border style="width: 100%">
          <el-table-column prop="item" label="项目"></el-table-column>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="days" label="时长">
            <template slot-scope="scope">
              <span>{{ scope.row.days }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="价格"></el-table-column>
        </el-table>
        <el-alert
          class="alert"
          style="margin-top: 10px;"
          title="支付描述"
          :type="renewAlertType"
          :closable="false"
          :description="renewPayDescription"
        ></el-alert>
        <el-button
          v-if="renewPayBtnShow"
          class="primary"
          style="margin-top: 10px; float: right;"
          @click="renewPay"
          >确认支付</el-button
        >
      </div>
      <div v-if="!renewPayTableShow" slot="footer" class="dialog-footer">
        <el-button @click="renewDialog = false">取 消</el-button>
        <el-button class="primary" @click="renewSubmit">预览价格</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import buyDialog from "./buyFdc.vue";
import transferDialog from "./transferDialog.vue";
import extensionDialog from "./extensionDialog.vue";

import {
  getFDCLocalList,
  FDCLocalUpdate,
  FDCLocalDelay,
  getFDCOrdersModules,
  FDCLocalAddUsersPrice,
  FDCLocalAddUsers,
  FDCLocalRenewPrice,
  FDCLocalRenew,
} from "@/api/afFdc";
import { getOrderByParam } from "@/api/order";
import { createGetUrlParams } from "@/utils/url";
import { authStatus } from "@/utils/dataDict";
import { payVerify } from "@/utils/pay";

export default {
  data() {
    var validatePass3 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (!/^[A-Za-z0-9]+$/.test(value)) {
        callback(new Error("密钥只支持数字和字母"));
      } else {
        if (this.editPasswordForm.checkPass !== "") {
          this.$refs.editPasswordForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass4 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (!/^[A-Za-z0-9]+$/.test(value)) {
        callback(new Error("密钥只支持数字和字母"));
      } else if (value !== this.editPasswordForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      drawer: false,
      purchasedProjects: [],
      orderList: [],
      pagination: {
        use: true,
        total: 0,
        size: 20,
        currentPage: 1,
      },
      orderPagination: {
        use: true,
        total: 0,
        size: 50,
        currentPage: 1,
      },
      curentId: 0,
      currentIndex: 0,
      searchOption: {
        name: "",
        code: "",
        username: "",
      },
      tableData: [],
      editCustomerDialog: false,
      editPasswordDialog: false,
      editCustomerForm: {
        code: "",
        name: "",
        contact_name: "",
        mobile: "",
        note: "",
      },
      editPasswordForm: {
        code: "",
        name: "",
        pass: "",
        checkPass: "",
      },
      editCustomerFormRules: {
        // mobile: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (value && !/^1[3-9]\d{9}$/.test(value)) {
        //         callback(new Error('请输入正确的11位手机号码'));
        //       } else {
        //         callback();
        //       }
        //     },
        //     trigger: 'blur',
        //   },
        // ],
      },
      editPasswordFormRules: {
        pass: [{ required: true, trigger: "blur", validator: validatePass3 }],
        checkPass: [
          { required: true, trigger: "blur", validator: validatePass4 },
        ],
      },
      activeName: "first",
      currentOrg: null,
      ordersModulesLoading: false,
      orderListLoading: false,
      is_superuser: false,
      buySiteDialog: false,
      buySiteForm: {
        name: "",
        code: "",
        current_bi_users: 0,
        current_std_users: 0,
        bi_users: 0,
        std_users: 0,
      },
      renewDialog: false,
      renewForm: {
        name: "",
        code: "",
        buy_type: 1,
        new_months: 1,
        note: "",
      },
      // 续费价格预览
      renewDialogTitle: "授权码续费",
      renewPayTableShow: false,
      renewPayTableData: [],
      renewPayDescription: "",
      renewAlertType: "success",
      renewPayBtnShow: false,
      renewPayData: null,
      // 增购站点价格预览
      buySitePayTableShow: false,
      buySitePayTableData: [],
      buySitePayDescription: "",
      buySiteAlertType: "success",
      buySitePayBtnShow: false,
      buySitePayData: null,
    };
  },
  mounted() {
    this.getAuthData();
    this.getUserInfo();
  },
  methods: {
    async getUserInfo() {
      const res = await this.$store.dispatch("user/userinfo");
      this.is_superuser = res.is_superuser;
    },
    authorizationTransfer(index, row) {
      this.$refs.transferDialog.show();
      this.$refs.transferDialog.initData(row, "fdc");
    },
    isExpired(row) {
      return new Date(row.expire_time) <= new Date();
    },
    delayClick(index, row) {
      this.$confirm(
        "您将对授权码进行延期操作（延期7天），是否继续进行？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        },
      )
        .then(() => {
          this.loading = true;
          FDCLocalDelay(row.id)
            .then(() => {
              this.loading = false;
              this.$message.success("延期成功!");
              this.getAuthData();
            })
            .catch(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          this.$message({ type: "info", message: "已取消操作" });
        });
    },
    trialExtension(index, row) {
      this.$refs.extensionDialog.show();
      this.$refs.extensionDialog.initData(row, "fdc");
    },
    trialModuleExtension(index, row) {
      this.$refs.extensionDialog.show();
      this.$refs.extensionDialog.initData(row, "fdc_module");
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getAuthData();
    },
    handleSizeChange(val) {
      if (val <= this.pagination.total) {
        this.pagination.size = val;
        this.getAuthData();
      }
    },
    handleCurrentChangeOrder(val) {
      this.orderPagination.currentPage = val;
      this.getOrderList();
    },
    handleSizeChangeOrder(val) {
      if (val <= this.orderPagination.total) {
        this.orderPagination.size = val;
        this.getOrderList();
      }
    },
    getOrderList() {
      let params = {
        p: this.orderPagination.currentPage,
        count: this.orderPagination.size,
        af_auth: this.curentId,
      };
      let result = createGetUrlParams(params);
      if (result.success) {
        getOrderByParam(result.data)
          .then((res) => {
            this.orderList = res.results || [];
            this.orderPagination.total = res.count;
            this.orderListLoading = false;
          })
          .catch(() => {
            this.orderList = [];
            this.orderListLoading = false;
          });
      } else {
        this.orderListLoading = false;
      }
    },
    checkBuyout(dateStr) {
      if (!dateStr) return "";
      try {
        const [datePart, timePart] = dateStr.split(" ");
        const [year, month, day] = datePart.split("-").map(Number);
        const [hours, minutes, seconds] = (timePart || "00:00:00")
          .split(":")
          .map(Number);
        const targetDate = new Date(
          year,
          month - 1,
          day,
          hours,
          minutes,
          seconds,
        );
        const cutoffDate = new Date(2099, 11, 31, 23, 59, 59);
        if (isNaN(targetDate.getTime())) return dateStr;
        return targetDate > cutoffDate ? "买断" : dateStr;
      } catch (e) {
        return dateStr;
      }
    },
    purchaseView(index, row) {
      this.activeName = "first";
      this.curentId = row.id;
      this.currentIndex = index;
      this.currentOrg = row;
      this.drawer = true;
      this.ordersModulesLoading = true;
      this.orderListLoading = true;
      getFDCOrdersModules(this.curentId)
        .then((res) => {
          this.ordersModulesLoading = false;
          this.purchasedProjects = res;
        })
        .catch(() => {
          this.ordersModulesLoading = false;
        });
      this.orderPagination.currentPage = 1;
      this.orderPagination.size = 50;
      this.getOrderList();
    },
    refreshAFOrdersApps() {
      getFDCOrdersModules(this.curentId)
        .then((res) => {
          this.ordersModulesLoading = false;
          this.purchasedProjects = res;
        })
        .catch(() => {
          this.ordersModulesLoading = false;
        });
    },
    buyModule(index, row) {
      this.curentId = row.id;
      this.currentIndex = index;
      this.currentOrg = row;
      this.$refs.buyDialog.isAdd = "buy";
      this.$refs.buyDialog.show(row);
    },
    buySiteOpen(index, row) {
      this.curentId = row.id;
      this.currentIndex = index;
      this.currentOrg = row;
      this.buySiteForm.name = row.name;
      this.buySiteForm.code = row.code;
      this.buySiteForm.current_bi_users = row.fdc_bi_users || 0;
      this.buySiteForm.current_std_users = row.fdc_std_users || 0;
      this.buySiteForm.bi_users = 0;
      this.buySiteForm.std_users = 0;
      this.buySitePayTableShow = false;
      this.buySiteDialog = true;
    },
    buySiteSubmit() {
      if (this.buySiteForm.bi_users === 0 && this.buySiteForm.std_users === 0) {
        this.$message.error("请至少增购一类用户数");
        return;
      }
      let priceObj = {
        std_users: this.buySiteForm.std_users,
        bi_users: this.buySiteForm.bi_users,
      };
      FDCLocalAddUsersPrice(this.curentId, priceObj)
        .then((res) => {
          this.$store.dispatch("user/userinfo").then(() => {
            let finance = {
              special: this.$store.getters.userInfo.finance.af_point,
              universal: this.$store.getters.userInfo.finance.point,
            };
            let parms = {
              price: res.total,
              payType: 1,
            };
            let result = payVerify(parms, finance);
            let daysDisplay =
              res.remaining_days === "买断"
                ? "买断"
                : res.remaining_days + "天";
            let tableData = [];
            if (res.bi_users > 0) {
              tableData.push({
                item: "工作用户",
                count: res.bi_users,
                days: daysDisplay,
                price: res.bi_price,
              });
            }
            if (res.std_users > 0) {
              tableData.push({
                item: "查看用户",
                count: res.std_users,
                days: daysDisplay,
                price: res.std_price,
              });
            }
            tableData.push({
              item: "合计",
              count: "",
              days: "",
              price: res.total,
            });
            this.buySitePayTableData = tableData;
            this.buySitePayDescription = result.msg;
            this.buySitePayBtnShow = result.success;
            this.buySiteAlertType = result.success ? "success" : "error";
            this.buySitePayData = priceObj;
            this.buySitePayTableShow = true;
          });
        })
        .catch(() => {});
    },
    buySitePay() {
      FDCLocalAddUsers(this.curentId, {
        std_users: this.buySitePayData.std_users,
        bi_users: this.buySitePayData.bi_users,
        pay_type: 1,
      }).then(() => {
        this.$message({ type: "success", message: "增购站点成功!" });
        this.buySiteDialog = false;
        this.buySitePayTableShow = false;
        this.getAuthData();
      });
    },
    closeBuySiteDialog(done) {
      if(this.buySitePayTableShow){
        this.buySitePayTableShow = false;
        return;
      }
      this.buySiteForm.bi_users = 0;
      this.buySiteForm.std_users = 0;
      this.buySitePayTableShow = false;
      done();
    },
    renewOpen(index, row) {
      this.curentId = row.id;
      this.currentIndex = index;
      this.currentOrg = row;
      this.renewForm.name = row.name;
      this.renewForm.code = row.code;
      this.renewForm.buy_type = 1;
      this.renewForm.new_months = 1;
      this.renewForm.note = "";
      this.renewPayTableShow = false;
      this.renewDialogTitle = row.status === 3 ? "购买" : "授权码续费";
      this.renewDialog = true;
    },
    renewSubmit() {
      let buyout = this.renewForm.buy_type == 1;
      let months = buyout ? 1200 : Number(this.renewForm.new_months) * 12;
      FDCLocalRenewPrice(this.curentId, { months: months })
        .then((res) => {
          this.$store.dispatch("user/userinfo").then(() => {
            let finance = {
              special: this.$store.getters.userInfo.finance.af_point,
              universal: this.$store.getters.userInfo.finance.point,
            };
            let parms = {
              price: res.total,
              payType: 1,
            };
            let result = payVerify(parms, finance);
            let tableData = [];
            // 续费模块
            let ndays = ""
            if (res.renew_bill && res.renew_bill.modules) {
              res.renew_bill.modules.forEach((m) => {
                ndays = m.days === "买断" ? "买断" : m.days + "天";
                tableData.push({
                  item: "续费模块",
                  name: m.name,
                  days: ndays,
                  price: m.price,
                });
              });
            }
            // 用户费用
            if (res.user_bill) {
              let isBuyout =
                res.renew_bill &&
                res.renew_bill.modules &&
                res.renew_bill.modules.length > 0 &&
                res.renew_bill.modules[0].days === "买断";
              if (res.user_bill.bi_users > 0) {
                tableData.push({
                  item: "续费用户许可",
                  name: "工作用户 x " + res.user_bill.bi_users,
                  days: ndays,
                  price: res.user_bill.bi_price,
                });
              }
              if (res.user_bill.std_users > 0) {
                tableData.push({
                  item: "续费用户许可",
                  name: "查看用户 x " + res.user_bill.std_users,
                  days: ndays,
                  price: res.user_bill.std_price,
                });
              }
            }
            // 新增模块
            if (
              res.new_module_bill &&
              res.new_module_bill.modules &&
              res.new_module_bill.modules.length > 0
            ) {
              res.new_module_bill.modules.forEach((m) => {
                tableData.push({
                  item: "新增模块",
                  name: m.name,
                  days: m.days === "买断" ? "买断" : m.days + "天",
                  price: m.price,
                });
              });
            }
            tableData.push({
              item: "合计",
              name: "",
              days: "",
              price: res.total,
            });
            this.renewPayTableData = tableData;
            this.renewPayDescription = result.msg;
            this.renewPayBtnShow = result.success;
            this.renewAlertType = result.success ? "success" : "error";
            this.renewPayData = { months: months };
            this.renewPayTableShow = true;
          });
        })
        .catch(() => {});
    },
    renewPay() {
      FDCLocalRenew(this.curentId, {
        months: this.renewPayData.months,
        pay_type: 1,
      }).then(() => {
        this.$message({ type: "success", message: "续费成功!" });
        this.renewDialog = false;
        this.renewPayTableShow = false;
        this.getAuthData();
      });
    },
    closeRenewDialog(done) {
      if(this.renewPayTableShow){
        this.renewPayTableShow = false;
        return;
      }
      this.renewForm.buy_type = 1;
      this.renewForm.new_months = 1;
      this.renewForm.note = "";
      this.renewPayTableShow = false;
      done();
    },
    getYears(months) {
      const year = months / 12;
      return year ? `${year}年` : "";
    },
    search() {
      this.restPage(false);
      let params = {
        code: this.searchOption.code,
        name: this.searchOption.name,
        username: this.searchOption.username,
      };
      let result = createGetUrlParams(params);
      if (result.success) {
        this.loading = true;
        getFDCLocalList(result.data)
          .then((response) => {
            this.tableData = response.results;
            this.pagination.total = response.count;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    restPage(isUsePagination) {
      this.pagination.use = isUsePagination;
      this.pagination.currentPage = 1;
      this.pagination.size = 20;
    },
    restSearch() {
      for (const key in this.searchOption) {
        if (this.searchOption.hasOwnProperty(key)) {
          this.searchOption[key] = "";
        }
      }
      this.restPage(true);
      this.getAuthData();
    },
    getAuthData() {
      this.loading = true;
      let params = {
        p: this.pagination.currentPage,
        count: this.pagination.size,
        code: this.searchOption.code,
        name: this.searchOption.name,
        username: this.searchOption.username,
      };
      let result = createGetUrlParams(params);
      if (result.success) {
        getFDCLocalList(result.data)
          .then((response) => {
            this.loading = false;
            this.pagination.total = response.count | 0;
            this.tableData = response.results;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    getAuthStatus(index) {
      return authStatus[index];
    },
    formatOrderDetail(row) {
      let parts = [];
      try {
        if (row.detail) {
          let detail = typeof row.detail === 'string' ? JSON.parse(row.detail) : row.detail;
          if (detail.renew_bill) {
            // 续费订单
            let userParts = [];
            if (detail.user_bill) {
              if (detail.user_bill.bi_users > 0) {
                userParts.push('续费工作用户 ' + detail.user_bill.bi_users + ' 个');
              }
              if (detail.user_bill.std_users > 0) {
                userParts.push('续费查看用户 ' + detail.user_bill.std_users + ' 个');
              }
            }
            if (userParts.length > 0) {
              parts.push(userParts.join('、'));
            }
            if (detail.renew_bill.modules && detail.renew_bill.modules.length > 0) {
              let renewNames = detail.renew_bill.modules.map(m => m.name).join('、');
              parts.push('续费模块: ' + renewNames);
            }
            if (detail.new_module_bill && detail.new_module_bill.modules && detail.new_module_bill.modules.length > 0) {
              let newModuleNames = detail.new_module_bill.modules.map(m => m.name).join('、');
              parts.push('新购模块: ' + newModuleNames);
            }
          } else if (detail.module_bill && detail.module_bill.modules && detail.module_bill.modules.length > 0) {
            // 增购模块
            let moduleNames = detail.module_bill.modules.map(m => m.name).join('、');
            parts.push('增购模块: ' + moduleNames);
          } else if (detail.bi_users !== undefined || detail.std_users !== undefined) {
            // 增购站点
            let userParts = [];
            if (detail.bi_users > 0) {
              userParts.push('增购工作用户 ' + detail.bi_users + ' 个');
            }
            if (detail.std_users > 0) {
              userParts.push('增购查看用户 ' + detail.std_users + ' 个');
            }
            if (userParts.length > 0) {
              parts.push(userParts.join('、'));
            }
          } else {
            // 其他情况
            if (detail.edition_bill) {
              parts.push(detail.edition_bill.name);
            }
            if (detail.app_bill && detail.app_bill.apps && detail.app_bill.apps.length > 0) {
              let appNames = detail.app_bill.apps.map(a => a.name).join('、');
              parts.push('应用: ' + appNames);
            }
          }
        }
      } catch (e) {}
      return parts.join('; ') || '-';
    },
    formatOrderDuration(row) {
      // 优先从 detail 中取实际天数
      try {
        if (row.detail) {
          let detail = typeof row.detail === 'string' ? JSON.parse(row.detail) : row.detail;
          let days = null;
          if (detail.renew_bill && detail.renew_bill.modules && detail.renew_bill.modules.length > 0) {
            days = detail.renew_bill.modules[0].days;
          } else if (detail.module_bill && detail.module_bill.modules && detail.module_bill.modules.length > 0) {
            days = detail.module_bill.modules[0].days;
          } else if (detail.new_module_bill && detail.new_module_bill.modules && detail.new_module_bill.modules.length > 0) {
            days = detail.new_module_bill.modules[0].days;
          }
          if (days !== null && days !== undefined) {
            if (days === '买断' || days >= 9999) return '买断';
            return days + ' 天';
          }
        }
      } catch (e) {}
      if (row.days > 0) {
        if (row.days >= 9999) return '买断';
        return row.days + ' 天';
      }
      if (row.months > 0) {
        if (row.months >= 9999) return '买断';
        return row.months * 30 + ' 天';
      }
      return '-';
    },
    triallDialogOpen() {
      this.$refs.buyDialog.isAdd = "triall";
      this.$refs.buyDialog.show();
    },
    buyFirstDialogOpen() {
      this.$refs.buyDialog.isAdd = "add";
      this.$refs.buyDialog.show();
    },
    editCustomerOpen(index, row) {
      this.curentId = row.id;
      this.currentIndex = index;
      this.editCustomerForm.code = row.code;
      this.editCustomerForm.name = row.name;
      this.editCustomerForm.contact_name = row.contact_name || "";
      this.editCustomerForm.mobile = row.mobile || "";
      this.editCustomerForm.note = row.note;
      this.editCustomerDialog = true;
    },
    editPasswordOpen(index, row) {
      this.curentId = row.id;
      this.currentIndex = index;
      this.editPasswordForm.checkPass = "";
      this.editPasswordForm.pass = "";
      this.editPasswordForm.code = row.code;
      this.editPasswordForm.name = row.name;
      this.editPasswordDialog = true;
    },
    editCustomerSubmit() {
      this.$refs.editCustomerForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          FDCLocalUpdate(this.curentId, {
            name: this.editCustomerForm.name,
            contact_name: this.editCustomerForm.contact_name,
            mobile: this.editCustomerForm.mobile,
            note: this.editCustomerForm.note,
          })
            .then(() => {
              this.loading = false;
              this.$message({ type: "success", message: "编辑信息成功" });
              this.getAuthData();
              this.editCustomerDialog = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    editPasswordSubmit() {
      this.$refs.editPasswordForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          FDCLocalUpdate(this.curentId, { key: this.editPasswordForm.pass })
            .then(() => {
              this.loading = false;
              this.$message({ type: "success", message: "修改密钥成功" });
              this.getAuthData();
              this.editPasswordDialog = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    restEditCustomerForm(done) {
      if (this.$refs.editCustomerForm)
        this.$refs.editCustomerForm.resetFields();
      done();
    },
    restEditPasswordForm(done) {
      if (this.$refs.editPasswordForm)
        this.$refs.editPasswordForm.resetFields();
      done();
    },
    cancel(formName, close) {
      this.$refs[formName].resetFields();
    },
  },
  components: {
    buyDialog,
    transferDialog,
    extensionDialog,
  },
};
</script>

<style lang="scss">
@import url("../../assets/css/product.css");

.el-drawer__body {
  height: calc(100% - 40px);
}

.el-drawer__header {
  margin-bottom: 10px;
  padding: 10px 10px 0;
}

.el-tabs {
  height: calc(100% - 40px);
}

.el-tabs__content {
  height: calc(100% - 54px);
}

.el-tab-pane {
  height: 100%;
}

.drawer_main1 {
  padding: 10px 20px;
  height: 100%;

  .title_main {
    // height: 102px;
    background: #ebeef5;
    border-radius: 6px;
    padding: 10px;
    margin-bottom: 20px;

    .title_top {
      color: #333;

      span {
        font-size: 18px;
        font-weight: bold;
      }
    }

    .title_mid {
      color: #565454;
      display: flex;
      font-size: 14px;
      margin: 10px 0px;
      justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;
      // gap: 60px;
      .item {
        display: flex;
        // width: 50%;
      }
    }

    .title_bottom {
      color: #565454;
      font-size: 14px;
    }
  }

  .table_main {
    height: calc(100% - 102px);
  }
}

.af_cloud {
  .main {
    display: flex;
    flex-direction: column;
    margin: 0px 14px;
    height: 100%;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;

    .main_title {
      margin: 15px 0;
    }

    .product-selector_main {
      display: flex;
      flex-wrap: wrap;
      width: calc(100% - 24px);
      background: #fff;
      padding: 10px 0px 20px 24px;
      min-width: 980px;
      font-size: 12px;

      .selector-item {
        display: flex;
        align-items: center;
        margin-right: 20px;
        margin-top: 10px;
      }
    }

    .selector-left_main {
      width: calc(100% - 200px);
      height: 100%;
      display: flex;
      flex-wrap: wrap;
    }

    .selector-right_main {
      width: 200px;
      height: 100%;
      display: flex;
      align-items: center;

      .buttons {
        margin-top: 10px;
        height: 32px;
      }
    }

    .product-main-list {
      flex-grow: 1;
      height: 50%;
    }
  }
}

.buy-site-info {
  padding: 0 0 18px 110px;
  font-size: 14px;
  color: #606266;
}

.editCustomerDialog input::-ms-reveal {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/agileFlow/fdcProduct.vue